<template>
    <div>
        <button type="button" 
            :class="`btn btn-purple ${tamanhoBotao}`" 
            :disabled="loading" 
            @click="usarLocalizacao()">
                {{ loading ? `Aguarde ...` : textoBotao }}
                 <i class="fas fa-map-marker-alt"></i>
        </button>
    </div>
</template>

<script>
import barramentoEndereco from '@/bus/endereco';
export default {
    data() {
        return {
            tamanhoBotao: 'btn-block',
            textoBotao: 'Usar minha localização',
            loading: false
        }
    },
    props: {
        corrigir: {
            type: Boolean,
            default: false
        },
        tipoEndereco: String,
        endereco: {
            type: Object,
            default: () => { return {} }
        },
        segundaSaida: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.corrigir) {
            this.tamanhoBotao = "btn-sm";
            this.textoBotao = "Corrigir";
        }
    },
    methods: {
        usarLocalizacao() {
            barramentoEndereco.$emit('editarEndereco', {endereco: this.endereco, tipo: this.tipoEndereco, segundaSaida: this.segundaSaida});
        }
    }
}
</script>